import React from "react";
import { IWalletTransaction, WALLET_TRANSACTION_ENUM } from "../../../../services/api/wallet-service";
import "./wallet-payment-method-error-transaction.scss";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import DateTimeV2, { DATETIME_VIEW } from "../../../../components/datetime-v2/datetime-v2";
import { useDateTimeFormattingParams } from "../../../../hooks/use-datetime-formatting-params";

interface IProps {
    attemptIndex: number;
    transaction: IWalletTransaction;
}

const WalletPaymentMethodErrorTransaction: React.FC<IProps> = ({ attemptIndex, transaction }) => {
    const isManualDeposit = transaction.type === WALLET_TRANSACTION_ENUM.TYPE_MANUAL_DEPOSIT;
    const dateTimeParams = useDateTimeFormattingParams();

    return (
        <div className="wallet-payment-method-error-transaction">
            {!isManualDeposit && (
                <FontBody1 variant={FONT_VARIANT.BOLD}>{`Attempt ${attemptIndex}`}</FontBody1>
            )}
            <FontBody1>
                <DateTimeV2 {...dateTimeParams} utcDateString={transaction.created_at} dateTimeView={DATETIME_VIEW.FULL} />
            </FontBody1>
            <FontBody1>{transaction.reason}</FontBody1>
        </div>
    );
};

export default WalletPaymentMethodErrorTransaction;
